import React from "react";

import "./CftMobileReportWrapper.scss";

function CftMobileReportWrapper({ children }) {
  return <div className="cft-mobile-report-wrapper">{children}</div>;
}

export default CftMobileReportWrapper;
